import type { FormFieldType } from "@newxsystems/types";
import type { ComponentType } from "react";

export interface FormSubmissionEntry {
  label: string;
  fieldType: FormFieldType;
  value: string | boolean;
}

export interface FormSubmissionPayload {
  fields: FormSubmissionEntry[];
  anchorId?: string;
  sourcePath?: string;
}

export type FormSubmitter = (payload: FormSubmissionPayload) => Promise<void>;

const components = new Map<string, ComponentType<any>>();
let formSubmitter: FormSubmitter | undefined;

export const registerComponent = (name: string, component: ComponentType<any>) => {
  components.set(name, component);
};

export const getComponent = <TProps>(name: string) =>
  components.get(name) as ComponentType<TProps> | undefined;

export const registerFormSubmitter = (submitter: FormSubmitter) => {
  formSubmitter = submitter;
};

export const getFormSubmitter = () => formSubmitter;
